import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomPhonePipe } from './custome-Pipes/phonePipe.componnet';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { CustomDateModule } from 'src/pipes/custom-date.pipe';
import { ToastrModule } from 'ngx-toastr';
import { ToastrModelService } from './toastr-model.service';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { HealthcheckComponent } from './healthcheck/healthcheck.component';
import { ApiService } from './api.service';
import { AuthComponent } from './auth/auth.component';
import { MessageBoxComponent } from './common/message-box/message-box.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthorizationInterceptor } from './interceptors/authorization.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
@NgModule({
	declarations: [
		AppComponent,
		CustomPhonePipe,
		HealthcheckComponent,
		AuthComponent,
		MessageBoxComponent,
	],
	bootstrap: [
		AppComponent
	], 
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		MatInputModule,
		MatChipsModule,
		CustomDateModule,
		ToastrModule.forRoot(),
		NgxUiLoaderModule,
		NgxUiLoaderHttpModule.forRoot({ showForeground: true })
	], 
	providers: [
		{
			provide: LocationStrategy,
			useClass: HashLocationStrategy
		},
		ToastrModelService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthorizationInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true
		},
		ApiService,
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimationsAsync()
	]
})
export class AppModule {
}
